import QuinceApiError from '../../domains/quince-api-error'
import { productReviewHttpClient } from '../../utils/HttpClient'

import {
  IGetProductReviewsAPIResponse,
  IGetProductReviewsPayload,
  IGetProductReviewsResponse,
  IProductReview,
} from './productReviewService.types'

class ProductReviewService {
  public async getProductReviews({
    ids,
    isWithPhotos = false,
    sortBy,
    sortOrder,
    pageSize,
    pageNumber = 0,
    ratings,
  }: IGetProductReviewsPayload): Promise<IGetProductReviewsResponse> {
    try {
      const { data: apiResponse } = await productReviewHttpClient.get<IGetProductReviewsAPIResponse>(
        '/reviews/external/fetch-reviews',
        {
          params: {
            quinceProductIds: ids.join(','),
            containsMedia: isWithPhotos,
            sortBy,
            sortDirection: sortOrder,
            pageSize,
            pageNumber,
            ratings,
          },
        },
      )
      return {
        reviews: apiResponse.content.map(makeProductReview),
        total: apiResponse.totalElements,
        hasNext: apiResponse.hasNext,
      }
    } catch (e) {
      throw new QuinceApiError({
        // @i18n-ignore
        apiName: 'get-product-reviews',
        // @i18n-ignore
        message: 'Failed while fetching reviews in Product Review service getProductReviews() runtime',
        error: e as Error,
      })
    }
  }
}

export const makeProductReview = (apiProductReview: IProductReview) => {
  return {
    id: apiProductReview.id,
    rating: apiProductReview.rating,
    title: apiProductReview.title,
    author: apiProductReview.author,
    productId: apiProductReview.productId,
    createdAt: new Date(apiProductReview.createdDate * 1000).toISOString(),
    body: apiProductReview.text,
    reviewOptions: apiProductReview.reviewAttributes,
    productTitle: apiProductReview.title,
    imagesFileUrls: apiProductReview.reviewMedias
      .filter(media => media.mediaType === 'IMAGE')
      .map(apiProductReview => apiProductReview.mediaUrl),
    source: apiProductReview.source,
    reviewTags: apiProductReview.reviewTags?.map(res => ({ tagValues: res?.tagValues, tags: res?.tags })),
  }
}

const productReviewService = new ProductReviewService()

export default productReviewService
